import { Datepicker, Button } from '@a-ui/react';
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react';
import { closeModal } from '../../../store/slices/modalReducer'
import { updateTask, fetchTask } from '../../../store/slices/tasksReducer'

const Planning = (props) => {
  const dispatch = useDispatch();
  const { task } = useSelector(state => state.tasks);
  const [ plannedStartDate, setPlannedStartDate ] = useState(undefined);
  const [ plannedStartTime, setPlannedStartTime ] = useState(null);
  const [ plannedEndDate, setPlannedEndDate ] = useState(null);
  const [ plannedEndTime, setPlannedEndTime ] = useState(null);

  const updateDateTime = (date, time, target) => {
    let dateValue = date;
    let dateSplitter = '/';
    if(date.indexOf('T') > -1){
      [ dateValue ] = date.split('T');
      dateSplitter = '-';
    }
    const timeSet = (time !== null) ? time : '00:00:00'
    const [ dd, mm, yyyy ] = dateValue.split(dateSplitter);
    target(`${dd}-${mm}-${yyyy}T${timeSet}:00`);
  }

  return <>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
         <label className="a-input__label u-margin-bottom-xs"><strong>Start</strong></label>
          <div className="row">
            <div className="col-xs-6 u-margin-bottom-xs">
              <div className="a-input planning-form">
                <Datepicker
                  inputProps={{
                    label: "Start Datum"
                  }}
                  format={"dd/MM/yyyy"}
                  mask={"99/99/9999"}
                  onChange={(date, isValid) => {
                    updateDateTime(date, plannedStartTime, setPlannedStartDate);
                  }}
                />
              </div>
            </div>
            <div className="col-xs-4 u-margin-bottom-xs">
              <div className="a-input">
                <label className="a-input__label" htmlFor="time-field">Start tijd</label>
                <div className="a-input__wrapper">
                  <input
                    type="time"
                    name="time-field"
                    id="time-field"
                    onChange={(e) => {
                      setPlannedStartTime(e.target.value);
                      updateDateTime(plannedStartDate, e.target.value, setPlannedStartDate);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12 u-margin-bottom-xs">
        <label className="a-input__label u-margin-bottom-xs"><strong>Einde</strong></label>
        <div className="row">
          <div className="col-xs-6 u-margin-bottom-xs">
            <div className="a-input planning-form">
              <Datepicker
                inputProps={{
                  label: "Einde Datum"
                }}
                format={"dd/MM/yyyy"}
                mask={"99/99/9999"}
                onChange={(date) => {
                  updateDateTime(date, plannedEndTime, setPlannedEndDate);
                }}
              />
            </div>
          </div>
          <div className="col-xs-4 u-margin-bottom-xs">
            <div className="a-input">
              <label className="a-input__label" htmlFor="time-field">Eind tijd</label>
              <div className="a-input__wrapper">
                <input type="time" name="time-field" id="time-field"
                  onChange={(e) => {
                    updateDateTime(plannedEndDate, e.target.value, setPlannedEndDate);
                    setPlannedEndTime(e.target.value);
                  }}
                  />
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12">
        <Button
          onClick={() => {
            dispatch(updateTask({
              plannedEndDate,
              plannedEndTime,
              plannedStartDate,
              plannedStartTime,
            }));
            dispatch(closeModal());
            dispatch(fetchTask(task.id));
          }}
        >
         Bevestigen
        </Button>
        <Button
          emphasis="low"
          onClick={() => {
            dispatch(closeModal())
          }}
        >
         annuleren
        </Button>
        <div className="datepickerpusher">
        </div>
      </div>
    </div>
  </>

}

export default Planning;
